/* CPPerformance homepage conversion mounts — conversion upgrade */
(function () {
  let finderNode = null;
  let finderSourceHolder = null;

  function mountFinder() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return;

    const hero = main.querySelector('.shopify-section:first-child .hero__container');
    const candidate = main.querySelector('[data-vehicle-finder]');
    if (!hero || !candidate) return;

    finderNode = candidate;
    if (!finderSourceHolder || !document.documentElement.contains(finderSourceHolder)) {
      finderSourceHolder = candidate.closest('.shopify-section');
    }

    if (!hero.contains(candidate)) {
      candidate.classList.add('vehicle-finder--hero');
      hero.appendChild(candidate);
    }

    if (finderSourceHolder && finderSourceHolder !== hero.closest('.shopify-section')) {
      finderSourceHolder.classList.add('cp-finder-source-empty');
    }
    document.documentElement.classList.add('cp-hero-finder-mounted');
  }

  function restoreBeforeUnload(event) {
    if (
      finderNode &&
      finderSourceHolder &&
      event.target &&
      event.target.contains(finderNode) &&
      document.documentElement.contains(finderSourceHolder)
    ) {
      finderSourceHolder.classList.remove('cp-finder-source-empty');
      finderSourceHolder.appendChild(finderNode);
      document.documentElement.classList.remove('cp-hero-finder-mounted');
    }
  }

  function mountAll() {
    mountFinder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:unload', restoreBeforeUnload);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });
})();
